import { useDebouncedCallback } from "use-debounce";

export const language = {};

export enum AdminRoles {
  SuperAdmin = "Super Admin",
  SponsoringAdmin = "Sponsoring Org Admin",
  ApprovingAdmin = "Approving Org Admin",
  MasterTrainer = "Master Trainer",
}

export const codeToTextMapper: Record<string, string> = {
  MASTER_TRAINER: "Master Trainer",
  REGISTERED_FACILITATOR: "Registered Facilitator",
  PROVISIONAL_FACILITATOR: "Provisional Facilitator",
  STUDENTS: "Students",
  BEC_PROVIDER: "BEC Provider",
  STUDENT: "Student",
};

export const adminRoleStatusFilters = {
  [AdminRoles.SuperAdmin]: [
    { label: "Approved", value: "APPROVED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Draft", value: "DRAFT" },
    { label: "In Progress", value: "INPROGRESS" },
    { label: "Pending", value: "PENDING" },
    { label: "Rejected", value: "REJECTED" },
  ],
  [AdminRoles.SponsoringAdmin]: [
    { label: "Approved", value: "APPROVED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Draft", value: "DRAFT" },
    { label: "In Progress", value: "INPROGRESS" },
    { label: "Pending", value: "PENDING" },
    { label: "Rejected", value: "REJECTED" },
  ],
  [AdminRoles.ApprovingAdmin]: [
    { label: "Approved", value: "APPROVED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "In Progress", value: "INPROGRESS" },
    { label: "Pending", value: "PENDING" },
    { label: "Rejected", value: "REJECTED" },
  ],
  [AdminRoles.MasterTrainer]: [
    { label: "Approved", value: "APPROVED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "In Progress", value: "INPROGRESS" },
  ],
};
export const FacilitatorHierarchy: Record<string, string> = {
  PROVISIONAL_FACILITATOR: "Registered Facilitator",
  REGISTERED_FACILITATOR: "Master Trainer",
  MASTER_TRAINER: "",
};

export const useDebouncedSearch = (
  fetchFunction: (searchTerm: string) => void,
  delay: number = 500
) => {
  return useDebouncedCallback((value: string) => {
    fetchFunction(value);
  }, delay);
};

export const useConditionalDebouncedSearch = (
  fetchFn: (...args: any[]) => void,
  condition: boolean,
  args: any[] = [],
  delay: number = 500
) => {
  return useDebouncedCallback((value: string) => {
    if (condition) {
      fetchFn(...args, value);
    }
  }, delay);
};